import { Link } from 'react-router-dom';
import { useApi } from '../../hooks/useApi.js';
import { getDashboardStats } from '../../api/adminApi.js';
import { fmtTime } from '../../utils/format.js';

const STATS = [
  { key: 'totalRevenue',   label: '累積營業額', prefix: 'NT$', accent: true },
  { key: 'monthRevenue',   label: '本月營業額', prefix: 'NT$' },
  { key: 'totalOrders',    label: '總訂單數',  suffix: ' 筆' },
  { key: 'pendingOrders',  label: '待處理訂單', suffix: ' 筆', warn: true },
  { key: 'totalProducts',  label: '上架商品',  suffix: ' 項' },
  { key: 'totalMembers',   label: '會員總數',   suffix: ' 人' },
  { key: 'newMembersThisMonth', label: '本月新會員', suffix: ' 人' },
];

function AdminDashboard() {
  const { data: stats, loading } = useApi(() => getDashboardStats(), []);

  if (loading || !stats) {
    return <div style={{ padding: 40, color: 'var(--ink-soft)' }}>載入中…</div>;
  }

  return (
    <>
      <div className="admin-page-head">
        <h1>儀表板<small>DASHBOARD · OVERVIEW</small></h1>
      </div>

      {/* 指標卡 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 32 }}>
        {STATS.map(s => (
          <div key={s.key} className="admin-card" style={{ padding: 20 }}>
            <div style={{ fontSize: 11, letterSpacing: '0.16em', color: 'var(--ink-soft)', fontWeight: 700, textTransform: 'uppercase', marginBottom: 10 }}>
              {s.label}
            </div>
            <div style={{
              font: '900 28px Inter, sans-serif',
              color: s.warn ? 'var(--red)' : (s.accent ? 'var(--navy)' : 'var(--ink-strong)'),
            }}>
              {s.prefix || ''}{stats[s.key]?.toLocaleString?.() ?? stats[s.key]}{s.suffix || ''}
            </div>
          </div>
        ))}
      </div>

      {/* 最新訂單（整排寬） */}
      <div className="admin-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 16 }}>
          <h3 style={{ font: '800 16px "Noto Sans TC", sans-serif', margin: 0, color: 'var(--navy)' }}>最新訂單</h3>
          <Link to="/admin/orders" style={{ font: '700 12px Inter, sans-serif', color: 'var(--navy)' }}>查看全部 →</Link>
        </div>
        {stats.recentOrders.length === 0
          ? <p style={{ color: 'var(--ink-soft)', fontSize: 13, padding: 20, textAlign: 'center' }}>目前沒有訂單</p>
          : (
            <table className="admin-table">
              <thead><tr><th>訂單編號</th><th>日期</th><th>金額</th><th>狀態</th></tr></thead>
              <tbody>
                {stats.recentOrders.map(o => (
                  <tr key={o.id}>
                    <td style={{ fontWeight: 700, color: 'var(--navy)' }}>
                      <Link to={`/admin/orders`} style={{ color: 'var(--navy)', textDecoration: 'none' }}>{o.id}</Link>
                    </td>
                    <td style={{ color: 'var(--ink-soft)' }}>{fmtTime(o.createdAt)}</td>
                    <td style={{ fontWeight: 800 }}>NT${(o.total ?? 0).toLocaleString()}</td>
                    <td><span className={`chip ${o.status}`}>{o.statusLabel}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </div>
    </>
  );
}

export default AdminDashboard;
